<table class="table" *ngIf="apartmentInfos">
  <caption style="margin-bottom: 1em;">
    Apartment infos
  </caption>
  <thead>
    <tr>
      <th class="left">Floor</th>
      <th class="left">Count</th>
      <th class="left">SvLantNos</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let apartmentInfo of apartmentInfos">
      <td class="left">{{apartmentInfo.floor}}</td>
      <td class="left">{{apartmentInfo.count}}</td>
      <td class="left">{{apartmentInfo.svLantNosString}}</td>
    </tr>
  </tbody>
</table>
